/* Uberflip GWL OB-9563 start here */
const { getParameterByName, loadTiles } = require('./handleFiltering');
const { replaceAsFeaturedTile } = require('../upcomingWebinar');

function newIcon() {
    const newicon = document.createElement('div');
    newicon.classList.add('new-icon');
    newicon.innerHTML = 'New';
    const featuredTile = document.querySelector('li.highlightTile');
    if (featuredTile && featuredTile.querySelector('p.custom-tile-label') === null) {
        const ptag = '<p class= "custom-tile-label"></p>';
        if (featuredTile.querySelector('.friendly-timestamp')) {
            featuredTile.querySelector('.friendly-timestamp').insertAdjacentHTML('afterend', ptag);
        }
    }
    if (featuredTile) {
        if (featuredTile.querySelector('p.custom-tile-label')) {
            featuredTile.querySelector('p.custom-tile-label').innerHTML = 'Featured';
        }
        featuredTile.insertAdjacentElement('afterbegin', newicon);
    }

    const Icons = window.NewIcon.Colors;
    Object.keys(Icons).map((streamID) => {
        const stream = document.querySelector(`.listing-page.stream-${streamID}`);
        if (stream) {
            const colorCode = Icons[streamID].colorcode;
            if (
                colorCode === '' &&
                colorCode === undefined
            ) {
                throw new ReferenceError('Error in custom New Icon settings');
            } else {
                featuredTile.querySelector('div.new-icon').style.backgroundColor = colorCode;
            }
        }
        return stream;
    });
}
/**
 * The stored value from our ajax call (so we only ever need to make one)
 */
let memoizedValue = null;

/**
 * Convert the html returned by the server to a jquery object for filtering later
 * @param {string} tileHtml 
 */
const parseHtmlString = (tileHtml) => $(tileHtml).filter('.tile');

/**
 * A memoized function that will return a jquery object of tiles from the server for the given stream
 */
const getTiles = () => {
    if (memoizedValue) {
        return Promise.resolve(memoizedValue.clone());
    }

    return new Promise((resolve, reject) => {
        const collectionId = $('#page-type-identifier').attr('data-collection-id');
        const hubUrl = '';
        $.get(
                `${hubUrl}/resources/hubsFront/ajax_loadAdditionalItems/?collectionId=${collectionId}&currentPage=-1&limit=0&featuredItemCount=0&embedded=0&excludeCTAs=true`
            )
            .success((data) => {
                const parsedTiles = parseHtmlString(data);
                memoizedValue = parsedTiles.clone();
                const tileContainer = document.querySelector('#collection-items ul.collection-items-container');
                // in this sample request, the function will remove any tiles in the
                // stream's tileContainer and replace it with data from our fetch call

                const tiles = [...document.querySelectorAll('#collection-items .tile')];
                if (tiles) {
                    // - Iterate over each tile
                    tiles.forEach((tile) => {
                        tile.remove();
                    });
                }
                tileContainer.insertAdjacentHTML('beforeend', data);
                $('#collection-items ul.collection-items-container').css('display', 'flex');
                const moveToTopBtn = document.getElementById('load-more');
                const liTags = document.querySelectorAll('ul.collection-items-container li.tile:not(.cta)');
                if (liTags) {
                    liTags.forEach((tags) => {
                        tags.style.setProperty('display', 'flex', 'important');
                        tags.style.setProperty('opacity', '1', 'important');
                        const images = tags.querySelector('.img');
                        if (images) {
                            images.classList.add('visible');
                        }

                    });
                }
                const firstTile = document.querySelector('ul.collection-items-container li.tile:not(.cta):first-of-type');
                if (firstTile) {
                    firstTile.classList.add('highlightTile');
                }
                if (moveToTopBtn) {
                    moveToTopBtn.style.display = 'none';
                }
                resolve(parsedTiles.clone());
                if (getParameterByName('filterParams=')) {
                    loadTiles();
                }
                replaceAsFeaturedTile;
                newIcon();
            })
            .fail(reject);
    });
};

module.exports = getTiles;
/* Uberflip GWL OB-9563 end here */


// WEBPACK FOOTER //
// ./script-partials/filter/getTiles.js